import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=79219d88&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79219d88')) {
      api.createRecord('79219d88', component.options)
    } else {
      api.reload('79219d88', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=79219d88&", function () {
      api.rerender('79219d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24CwhT4Hl8rws/JS/comp/ImgFallback.vue"
export default component.exports